// Spreadsheet layout (all values in pixels)
// Up to three lines of column name (16px each) with a little room around them: as
// much as the old 66px header showed, so no name that read in full before is cut.
export const HEADER_HEIGHT = 64
export const HEADER_HEIGHT_CLASS = 'h-[63px]'
// The row count footer is a single label row.
export const STATS_HEIGHT = 36
export const ROW_PADDING = 16
export const SCROLLBAR_SIZE = 6
export const ROW_NUMBER_COLUMN_WIDTH = 60
export const ROW_NUMBER_COLUMN_WIDTH_CLASS = 'w-[60px]'
export const COLUMN_MIN_WIDTH = 100
export const COLUMN_MIN_WIDTH_CLASS = 'min-w-[100px]'
export const DEFAULT_MENU_WIDTH = 100
export const TOOLBAR_MENU_OFFSET = 80
export const OPTION_MIN_HEIGHT = 30
export const OPTION_OFFSET = 15
export const SECONDARY_TINT = -20

export const TOOLBAR_HEIGHT_CLASS = 'h-[44px]'

export const BUTTON_WIDTH_CLASS = 'w-[185px]'

// Row heights
export const SMALL_ROW_HEIGHT = 33
export const MEDIUM_ROW_HEIGHT = 66
export const TALL_ROW_HEIGHT = 99
export const EXTRA_TALL_ROW_HEIGHT = 132

export const SMALL_ROW_HEIGHT_CLASS = 'h-[33px]'
export const MEDIUM_ROW_HEIGHT_CLASS = 'h-[66px]'
export const TALL_ROW_HEIGHT_CLASS = 'h-[99px]'
export const EXTRA_TALL_ROW_HEIGHT_CLASS = 'h-[132px]'

export const SMALL_ROW_MAX_HEIGHT_CLASS = 'max-h-[33px]'
export const MEDIUM_ROW_MAX_HEIGHT_CLASS = 'max-h-[66px]'
export const TALL_ROW_MAX_HEIGHT_CLASS = 'max-h-[99px]'
export const EXTRA_TALL_ROW_MAX_HEIGHT_CLASS = 'max-h-[132px]'

export const SMALL_ROW_MIN_HEIGHT_CLASS = 'min-h-[33px]'
export const MEDIUM_ROW_MIN_HEIGHT_CLASS = 'min-h-[66px]'
export const TALL_ROW_MIN_HEIGHT_CLASS = 'min-h-[99px]'
export const EXTRA_TALL_ROW_MIN_HEIGHT_CLASS = 'min-h-[132px]'

export const SMALL_ROW_HEIGHT_BACKGROUND_CLASS = '[background-size:66px_66px]'
export const MEDIUM_ROW_HEIGHT_BACKGROUND_CLASS = '[background-size:132px_132px]'
export const TALL_ROW_HEIGHT_BACKGROUND_CLASS = '[background-size:198px_198px]'
export const EXTRA_TALL_ROW_HEIGHT_BACKGROUND_CLASS = '[background-size:264px_264px]'

export const ROW_HEIGHTS = {
  0: SMALL_ROW_HEIGHT,
  1: MEDIUM_ROW_HEIGHT,
  2: TALL_ROW_HEIGHT,
  3: EXTRA_TALL_ROW_HEIGHT
} as const
